import {
  CollectionBuilderComponent,
  overrideBuilderModel,
} from '@techstyle/react-builder-models';

import {
  overrides,
  excludeInputs,
} from '../BuilderCollection/BuilderCollection.builder';

import { DEFAULT_VALUES_SXF_RECOMMENDED_PRODUCTS } from './const';

const base = { ...overrides };

// This component shares most inputs with the SXF Collection component, so
// we use those. For most inputs, the only difference is the default values.
export const recommendedProductsOverrides = {
  name: '_RecommendedProducts_',
  defaultStyles: base.defaultStyles,
  inputs: [
    ...base.inputs
      .filter(element => element?.name !== 'gridOptions')
      .map(input => {
        if (DEFAULT_VALUES_SXF_RECOMMENDED_PRODUCTS[input.name]) {
          return {
            ...input,
            defaultValue: DEFAULT_VALUES_SXF_RECOMMENDED_PRODUCTS[input.name],
          };
        }
        return input;
      }),
    {
      name: 'devDefined',
      advanced: true,
      type: 'json',
      defaultValue: DEFAULT_VALUES_SXF_RECOMMENDED_PRODUCTS.devDefined,
    },
    {
      name: 'gridOptions',
      friendlyName: 'Grid Options',
      type: 'object',
      defaultValue: {
        showBottomText: true,
      },
      subFields: [
        {
          name: 'blocks',
          type: 'list',
          copyOnAdd: false,
          broadcast: true,
          subFields: [
            {
              name: 'content',
              type: 'uiBlocks',
              defaultValue: [],
            },
            {
              name: 'uiHelper',
              helperText:
                'Only used to display a title on each block inside the Builder editor.',
              type: 'string',
              defaultValue: 'Position',
              hidden: true,
            },
            {
              name: 'position',
              type: 'string',
              defaultValue: 1,
            },
            {
              name: 'width',
              type: 'number',
              defaultValue: 1,
            },
            {
              name: 'height',
              type: 'number',
              defaultValue: 1,
            },
            {
              name: 'widthMobile',
              helperText:
                'If empty, value will be ignored and width on mobile will be automatically set.',
              type: 'number',
              defaultValue: null,
            },
            {
              name: 'heightMobile',
              helperText:
                'If empty, value will be ignored and height on mobile will be automatically set.',
              type: 'number',
              defaultValue: null,
            },
          ],
          defaultValue: [],
        },
        {
          name: 'gridAssetContainer',
          type: 'string',
        },
        {
          name: 'gridAssetContainerMobile',
          type: 'string',
        },
        {
          name: 'sideNav',
          friendlyName: 'Side Nav Settings',
          type: 'object',
          subFields: [
            {
              name: 'showSideNav',
              type: 'boolean',
              defaultValue: false,
              helperText: 'Ignored on Carousel grids',
            },
            {
              name: 'showHeaderLabel',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'showSort',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'showHeader',
              type: 'boolean',
              defaultValue: false,
            },
            {
              name: 'showBreadcrumbs',
              type: 'boolean',
              defaultValue: false,
            },
          ],
        },
        {
          name: 'elementsToHide',
          defaultValue: {
            colorsAvailable: false,
            flags: false,
            overlay: false,
            price: false,
            promo: false,
            reviewStars: false,
            wishlist: false,
          },
          type: 'object',
          subFields: [
            {
              name: 'colorsAvailable',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'flags',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'price',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'promo',
              type: 'boolean',
              defaultValue: true,
            },
            {
              name: 'wishlist',
              type: 'boolean',
            },
          ],
        },
        {
          name: 'inlineSizeCategory',
          type: 'string',
          enum: ['All', 'Bras', 'Bralettes', 'Undies', 'Lingerie', 'Sleep'],
          defaultValue: null,
        },
        {
          name: 'inlineSizeAsset',
          type: 'boolean',
          defaultValue: false,
        },
        {
          name: 'showDescriptiveText',
          type: 'boolean',
          defaultValue: true,
        },
        {
          name: 'showLaydown',
          type: 'boolean',
          defaultValue: false,
        },
        {
          name: 'shouldTrackProductPriceViewed',
          type: 'boolean',
          defaultValue: false,
          helperText:
            "Send 'Product Price Viewed' event when price comes into view.",
        },
      ],
    },
  ],
};

const SXFRecommendedProductsBuilderComponent = overrideBuilderModel({
  base: CollectionBuilderComponent,
  overrides: recommendedProductsOverrides,
  excludeInputs,
});

export default SXFRecommendedProductsBuilderComponent;

export const BuilderRecommendedProductsConfig = {
  ...SXFRecommendedProductsBuilderComponent,
};
